import { render } from "./OBS.vue?vue&type=template&id=239b9c9c&scoped=true"
import script from "./OBS.vue?vue&type=script&lang=js"
export * from "./OBS.vue?vue&type=script&lang=js"

import "./OBS.vue?vue&type=style&index=0&id=239b9c9c&lang=css"
import "./OBS.vue?vue&type=style&index=1&id=239b9c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239b9c9c"]])

export default __exports__